import React from 'react';
import './TotalHeader.scss';

import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const MAIN_CLASS = 'analytics-table';
const CLASSES = {
  TOTALS: `${MAIN_CLASS}__totals`,
  TOTAL_ITEM: `${MAIN_CLASS}__totals__item`,
};

interface TotalsDataProps {
  headers: string[];
  values: string[];
  isLoading: boolean;
}

const TotalHeader: React.FC<TotalsDataProps> = ({ headers, values, isLoading }) => {
  return (
    <div className={CLASSES.TOTALS}>
      {headers.map((header, index) => (
        <div key={header} className={CLASSES.TOTAL_ITEM}>
          <h4>{header}</h4>
          {!isLoading ? values[index] || 'N/A' : <Skeleton width={40} height={24} />}
        </div>
      ))}
    </div>
  );
};

export default TotalHeader;
